goog.provide('el8.app.shared.dialog.reportAttachmentGroups');

goog.require('el8.data.reportTypes');
goog.require('el8.ptdata.fetch');
goog.require('el8.service.urls');
goog.require('el8.template.appchart.reportFeeds');
goog.require('el8.template.app.shared.dialog.reportItemsAttachments');
goog.require('el8.uiwidget.Feed');
goog.require('el8.uiwidget.FilterableFeed');
goog.require('el8.uiwidget.ClientConstructedFeed');
goog.require('el8.util.consts');

//
// Stripped down from attachmentGroups.js -- could likely be cut down more...
//
el8.app.shared.dialog.reportAttachmentGroups = (function() {
    var isAttachedFn = null; // used to check with selectAttachments if an item should be rendered selected
    var feedList = {};
    var patientId = null; // Optional -- passed in when used in phome

    function createAttachmentFeed(spec) {
        var name = spec.name;

        // The feed will show async, so if the user switches tabs before the feed renders,
        // we can get a race condition where feed A is fetching, we switch to feed B, which hides
        // feed A, but then feed A finishes fetching and shows itself again. Making the feed
        // container a div inside the main container prevents this.
        var $groupContainer = spec.container;
        $groupContainer.html(el8.template.app.shared.dialog.reportItemsAttachments.groupFeedContainer());
        var $feedContainer = $('.grouped-nav-feed', $groupContainer);

        var _fetchFn = spec.fetchFn || el8.ptdata.fetch;

        // If we have a ptid, wrap the default el8.ptdata.fetch callback adding to the "new-style" opts
        if (patientId) {
            _fetchFn = function(arg, force, async, callbackFn) {
                var fetchIds = null;

                // Support a single id as argument -- not sure if we need this, but keeping
                if (!(arg instanceof Array)) {
                    fetchIds = arg['id'];
                } else {
                    fetchIds = arg.map(function(a) { return a['id']; });
                }

                var opts =  {
                    fetchIds: fetchIds,
                    force: force,
                    async: async,
                    callbackFn: callbackFn,
                    patientId: patientId
                };
                return el8.ptdata.fetch(opts);
            };
        }

        var constructorArgs = {
            container: $feedContainer,
            name: name,
            urlIndex: spec.url,
            preProcessIndexFn: spec.preProcessFeedFn,
            emptyMsg: 'No items to be displayed',
            rendererFn: function(item) {
                var mClass = item.getModelClass();
                return function(item, feedId) {
                    var mapped = item.asSoyMap();

                    // We're in phome, don't show links
                    if (el8Globals.APP === 'home') {
                        mapped.noAttachmentLinks = true;
                    }

                    return el8.template.app.shared.dialog.reportItemsAttachments.feedElem({
                        feedId: feedId,
                        feedItemId: item.getFeedItemId(),
                        attachment: mapped,
                        // we need different styling if this item is already selected
                        isAttached: isAttachedFn(mClass, item)
                    });
                };
            },
            fetchFn: _fetchFn,
            pageSize: el8.util.consts.REPORT_FEED_PAGESIZE,
            navMode: 'feed',
            moreTrigger: '#attachment-feed-'+name+'-more-btn',
            skeletonFn: function(spec) {
                spec = spec || {};
                spec['buttonId'] = 'attachment-feed-'+name+'-more-btn';
                return el8.template.appchart.reportFeeds.feed(spec);
            },
            contentWrapperClass: 'overlayFeedItem',
            feedDateFn: function(item) { return item.getDocumentDate(); }
        };
        if (spec.fixedIndex) {
            $.extend(constructorArgs, {
                fixedIndex: spec.fixedIndex
            });
        }

        var FeedConstructor = el8.uiwidget.Feed;
        if (spec.fixedIndex) { FeedConstructor = el8.uiwidget.ClientConstructedFeed; }
        var feed = new FeedConstructor(constructorArgs);

        feedList[name] = feed;
    }

    function createAttachmentReportFeed($container, name) {
        var rType = el8Globals.AVAILABLE_REPORT_TYPES_BY_KEY[name];
        createAttachmentFeed({
            container: $container,
            name: name,
            url: el8.service.urls.get('createAttachmentReportFeed', [patientId, rType.id])
        });
    }

    function tabShowFn($container, name) {
        if (feedList[name]) {
            feedList[name].display();
        }
    }

    return {
        groups: function(spec) {
            // Save pt id if we got one for use in createAttachmentReportFeed(), otherwise use global
            patientId = spec.patientId || el8Globals['PATIENT_ID'];

            // For the "generic" attachment dlg, this is super complicated with a "popular" section
            // lots of code for various document types, etc. For our purposes we just use the
            // extracted reports code to make one groups with multiple sections of report types
            var allReportTypes = spec.allReportTypes || false;
            var reportTypeIds = null;

            var result = [
                {
                    title: 'Reports',
                    sections: [] // will be dynamically populated below
                }
            ];

            // In the chart report types are dynamic. In phome we'll get the whole set (including
            // practice configured)
            if (allReportTypes) {
                el8.data.reportTypes.softLoad();
                reportTypeIds = _.map(el8.data.reportTypes.all(), function(rt) { return rt.getId(); });
            } else {
                reportTypeIds = el8.appchart.reportFeeds.main.getCurrentReportTypeIds();
            }

            // Fill in the report section with the report types we got
            result[0]['sections'] = reportTypeIds.map(this.getReportFeedSpec);
            return result;
        },

        getReportFeedSpec: function(rTypeId) {
            var rType = el8Globals.AVAILABLE_REPORT_TYPES[rTypeId];
            return {
                name: el8Globals.AVAILABLE_REPORT_TYPES[rTypeId].report_type_label.toLowerCase(),
                label: rType.nickname,
                initFn: createAttachmentReportFeed,
                showFn: tabShowFn
            };
        },

        getFeedByName: function(name) {
            return (feedList[name]) ? feedList[name] : null;
        },

        setIsAttachedFn: function(callbackFn) {
            isAttachedFn = callbackFn;
        }
    };

})();
